import React from 'react'
import { getLatestMessagePreview } from 'stream-chat-react'
import MaterialSymbol from 'components/material-symbol/material-symbol'
import {
  getChannelLatestMessage,
  formatChannelPreviewText,
} from './messaging-utils'

const MessagingChannelPreviewAttachment = () => (
  <span className="messaging-channel-preview-attachment">
    <MaterialSymbol
      className="messaging-channel-preview-attachment__icon"
      fontSize={16}
      name="attach_file"
    />
    <span className="messaging-channel-preview-attachment__label">
      Attachment...
    </span>
  </span>
)

export const isAttachmentPreviewText = text =>
  typeof text === 'string' && text.includes('Attachment')

export const getMessagingLatestMessagePreview = (
  channel,
  t,
  userLanguage,
  isMessageAIGenerated,
) => {
  const latestMessage = getChannelLatestMessage(channel)

  if (latestMessage?.attachments?.length) {
    const previewText =
      latestMessage?.i18n?.[`${userLanguage}_text`] || latestMessage?.text

    if (!previewText && !latestMessage.command && !latestMessage.poll) {
      return <MessagingChannelPreviewAttachment />
    }
  }

  const previewText =
    latestMessage?.i18n?.[`${userLanguage}_text`] || latestMessage?.text

  if (previewText) {
    return previewText
  }

  const preview = getLatestMessagePreview(
    channel,
    t,
    userLanguage,
    isMessageAIGenerated,
  )

  if (isAttachmentPreviewText(preview)) {
    return <MessagingChannelPreviewAttachment />
  }

  if (typeof preview === 'string') {
    return formatChannelPreviewText(preview)
  }

  return preview
}

export default MessagingChannelPreviewAttachment
